import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { get } from '../../utils/api'

export const OBSERVATIONS_COUNT_KEY = 'observations-count'

export const useObservationsCount = (productId: number) => {
  const queryClient = useQueryClient()

  const { data } = useQuery(
    [OBSERVATIONS_COUNT_KEY, productId],
    () =>
      get<{ count: number }>(
        `/observations/?product=${productId}&limit=0`
      ).then((res) => res.count),
    { staleTime: 0, enabled: productId > 0 }
  )

  const { pathname } = useLocation()

  // Refetch on every section navigation
  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: [OBSERVATIONS_COUNT_KEY, productId],
    })
  }, [pathname, queryClient, productId])

  useEffect(() => {
    const handler = () => {
      queryClient.invalidateQueries({
        queryKey: [OBSERVATIONS_COUNT_KEY, productId],
      })
      // Re-fetch after a delay to handle backend bulk-delete race conditions
      // (the API may return 200 before all rows are fully committed)
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: [OBSERVATIONS_COUNT_KEY, productId],
        })
      }, 2000)
    }
    window.addEventListener('observations-changed', handler)
    return () => window.removeEventListener('observations-changed', handler)
  }, [queryClient, productId])

  return data ?? 0
}
